export enum ProductTrioTaskCreationRoleStatusEnum {
  GOOD = 'good',
  MEDIUM = 'medium',
  POOR = 'poor',
  UNASSIGNED = 'unassigned',
  NO_TASKS = 'no-tasks',
}
